module.exports = __webpack_public_path__ + "img/ch24.7e635505.png";